@use "styles/mixins/_rem.scss" as rem;

.icon {
  width: rem.torem(32px);
  height: rem.torem(32px);
}

.image > .img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: var(--size-border-radius-s);
}

.image.s {
  width: 40px;
  height: 40px;
}

.image.m {
  width: 80px;
  height: 80px;
}

.image.l {
  width: 120px;
  height: 120px;

  .img {
    border-radius: var(--size-border-radius-m);
  }
}
